import axios from "axios";

// const getBaseUrl = () => {
//   const user = JSON.parse(localStorage.getItem("user") ?? "{}");
//   return user?.profile === "PRODUCTION"
//     ? "https://ecommercetest.up-ng.com:8090/api"
//     : "https://test.payarena.com:8090/api";
// };

const https = () => {
  let options = {
    baseURL: "https://pay.mypayloft.com/",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };
  if (localStorage.getItem("token")) {
    options.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  return axios.create(options);
};

export default https;
